module.exports = __webpack_public_path__ + "img/noBindDevice.65193eaf.svg";